import { useContext } from "react";
import { TranslationsContext } from "../providers/TranslationsProvider";

export const useTranslations = () => {
  return useContext(TranslationsContext);
};
